import { NAV_LINKS } from "../../constants/navLinks";
import "./MobileTabBar.css";

const MobileTabBar = ({ activeId }) => (
  <nav className="tabbar" aria-label="Mobile navigation">
    <ul>
      {NAV_LINKS.map((l) => {
        const id = l.href.slice(1);
        const isActive = activeId === id;
        return (
          <li key={l.href}>
            <a
              href={l.href}
              className={`tabbar__item ${isActive ? "tabbar__item--active" : ""}`}
              aria-current={isActive ? "page" : undefined}
            >
              <i className={l.icon} />
              <span>{l.label}</span>
            </a>
          </li>
        );
      })}
    </ul>
  </nav>
);

export default MobileTabBar;
